export default {
  addThisConfig: {
    shareTitle: 'More reasons to celebrate!',
  },
  mainTitle: 'Wann hast du Geburtstag?',
  dateForm: {
    inputLabels: {
      day: 'Tag',
      month: 'Monat',
      time: 'Uhrzeit',
      year: 'Jahr',
    },
    submitButton: 'Zeige mein Alter in Sekunden, Stunden oder Tagen',
  },
  birthDateBreakdown: {
    subTitle: 'Danke fürs Eingeben!',
    title: 'So alt bist du:',
    rowsNames: {
      days: 'tage',
      hours: 'stunden',
      minutes: 'minuten',
      months: 'monate',
      seconds: 'sekunden',
      weeks: 'wochen',
    },
    nextSectionButton: 'Zeige meine Jubiläen',
  },
  occasions: {
    daysAgo: 'vor {value} Tagen',
    futureTitle: 'Nächste Jubiläen',
    inXDays: 'in {value} Tagen',
    old: 'alt',
    on: 'am',
    pastTitle: 'Vergangene Jubiläen',
    periodsLabels: {
      days: 'Tage',
      hours: 'Stunden',
      minutes: 'Minuten',
      months: 'Monate',
      seconds: 'Sekunden',
    },
    youLlBe: 'Du wirst',
    youWere: 'Du warst',
  },
  futureOccasionsReminders: {
    dateTypes: {
      days: 'Tage',
      months: 'Monate',
      seconds: 'Sekunden',
    },
    remindButton: 'Zukünftig erinnern',
    occasionRemindButton: {
      default: 'Erinner mich!',
      selected: 'Ausgewählt',
    },
    title: 'Nächste <span>Jubiläen</span>',
  },
  sideControls: {
    pageDownLabel: 'Weiter',
    pageUpLabel: 'Zurück',
  },
}
